import { ADD_FAVORITE } from "../action/action-types";

export default function favorites(state = [], action){
    switch(action.type){
        case ADD_FAVORITE:
            return [ ...state, action.payload ]
        default:
            return state
    }
}